import * as React from "react";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";

interface State {}

interface Props extends WithStyles<typeof styles> {
	progress: number;
}

export class LinearProgressbar extends React.Component<Props, State> {
	public state: State = {};

	private getColor = (progress: number) => {
		if (progress < 0) progress = 0;
		if (progress > 1) progress = 1;

		const hue = (progress * 120).toString(10);

		return ["hsl(", hue, ", 90%, 50%)"].join("");
	};

	public render() {
		const { classes } = this.props;
		const progress = isNaN(this.props.progress) ? 0 : this.props.progress;

		return (
			<div className={classes.root}>
				<div
					className={classes.bgBar}
					style={{
						backgroundColor: this.getColor(progress)
					}}
				/>
				<div
					className={classes.bar}
					style={{
						width: `${progress * 100}%`,
						backgroundColor: this.getColor(progress)
					}}
				/>
			</div>
		);
	}
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			width: "100%",
			height: 10,
			position: "relative",
			boxShadow: "1px 1px 3px rgba(0, 0, 0, 0.1)"
		},
		bgBar: {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			opacity: 0.1,
			zIndex: 1
		},
		bar: {
			position: "absolute",
			top: 0,
			left: 0,
			height: "100%",
			zIndex: 2
		}
	});

export const ConnectedLinearProgressbar = withStyles(styles)(LinearProgressbar);
